module.exports = __webpack_public_path__ + "img/384.d6bb0f70.jpg";